/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Rename_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to rename team. Please try again." |
*
* @param {Teams_Rename_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_rename_error = /** @type {((inputs?: Teams_Rename_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Rename_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Team konnte nicht umbenannt werden. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Failed to rename team. Please try again.")
});